import { render, staticRenderFns } from "./SettingsUserListing.vue?vue&type=template&id=5563568e&scoped=true"
import script from "./SettingsUserListing.vue?vue&type=script&lang=js"
export * from "./SettingsUserListing.vue?vue&type=script&lang=js"
import style0 from "./SettingsUserListing.vue?vue&type=style&index=0&id=5563568e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5563568e",
  null
  
)

export default component.exports